<template>
    <div class="container-fluid my-1">
        <div v-if="$_store.state.typeEventPrizeDrawClient.type === 'E'">
            <div class="ps-2 pe-2 mb-3">
                <label for="name" class="form-label"
                  >Nome do cliente</label
                >
                <input
                  v-model="nameClient"
                  type="text"
                  class="form-control"
                  id="name"
                  required
                  placeholder="Nome do Cliente"
                />
                <p class="p-error-label">{{ errorLabel?.nameClient || errorLabel?.error }}</p>
            </div>
    
            <div class="ps-2 pe-2 mb-3">
                <label for="name" class="form-label"
                  >Quantidade de Cupom</label
                >
                <input
                  v-model="coupon"
                  type="number"
                  class="form-control"
                  id="count"
                  required
                  placeholder="Quantidade de Cupom"
                />
                <p class="p-error-label">{{ errorLabel?.coupon || errorLabel?.error }}</p>
            </div>

            <div class="d-flex justify-content-center mb-2">
                <button 
                    class="btn btn-dark me-1 col-6" 
                    @click="sendEditPrizeDrawClient"
                    :disabled="!nameClient ? true : false"
                >
                Confirmar
                </button>
                <button 
                    id="closeButtonEdit"
                    class="btn btn-outline-danger ms-1 col-6" 
                    data-bs-dismiss="modal" 
                    aria-label="Close">
                    Cancelar
                </button>
            </div> 
        </div>
        <div v-else>
            <div class="d-flex justify-content-center mb-2">
                <button 
                    class="btn btn-dark me-1 col-6"
                    @click="sendDeletePrizedrawClient"
                >
                Confirmar
                </button>
                <button 
                    id="closeButton" 
                    class="btn btn-outline-danger ms-1 col-6" 
                    data-bs-dismiss="modal" 
                    aria-label="Close">
                    Cancelar
                </button>
            </div> 
        </div> 
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import store from "../../store";
import { deletePrizedrawClient, editPrizedrawClient } from "../../http";

export default {
setup() {

    const eventPrizeDrawClient = computed(() => store.state.typeEventPrizeDrawClient);
    const nameClient = ref('');
    const coupon = ref(0); 
    const prizedraw = computed(() => store.state.prizedraw);
    
    const errorLabel = ref({
        nameClient: null,
        coupon: null,
        error: null
    })


    const sendEditPrizeDrawClient = async () => {
        if(nameClient.value){
            const payload = {coupon: coupon.value, name: nameClient.value};
            await editPrizedrawClient(eventPrizeDrawClient.value?.client.id, payload)
                .then((data)=>{
                if(!data?.status){
                    errorLabel.value.error = data?.message;
                    return;
                }
                payload.id = eventPrizeDrawClient.value?.client.id;
                store.dispatch('updatePrizeDrawClient', {type: 'E', data: payload});
                nameClient.value = '';
                coupon.value = 0;
                document.getElementById("closeButtonEdit").click();

                });
        }else{
            errorLabel.value.nameClient = "Campo obrigatório.";
            errorLabel.value.coupon = "Campo obrigatório.";
        }
    }

    const sendDeletePrizedrawClient = async () => {
        await deletePrizedrawClient(eventPrizeDrawClient.value?.client.id)
            .then(() => {
                store.dispatch('updatePrizeDrawClient', {type: 'D', data: {id: eventPrizeDrawClient.value?.client.id}});
                document.getElementById("closeButton").click();
        });

    }

    watch(eventPrizeDrawClient, (newValue) => {
        if(newValue?.client){
            nameClient.value = newValue?.client?.name
            coupon.value = newValue?.client.coupon
        }
    });

     return {
        nameClient,
        coupon,
        sendEditPrizeDrawClient,
        sendDeletePrizedrawClient,
        prizedraw
  };
}
};
</script>

<style>
.p-error-label {
  font-size: 14px;
  color: red;
}
</style>
